import { render, staticRenderFns } from "./WhatsAppTemplateManager.vue?vue&type=template&id=4533e538&scoped=true&lang=pug&"
import script from "./WhatsAppTemplateManager.vue?vue&type=script&lang=js&"
export * from "./WhatsAppTemplateManager.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppTemplateManager.vue?vue&type=style&index=0&id=4533e538&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4533e538",
  null
  
)

/* custom blocks */
import block0 from "./WhatsAppTemplateManager.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports